import { createSelector } from '@ngrx/store';
import { Printer } from '../../../models';
import { AppState } from '../app.state';

export const selectPrinters = createSelector(
  (state: AppState) => state.printers,
  (printers: Printer[]) => printers
);
